import React, { useMemo } from 'react';
import { CpWidgetVariantType } from 'api/customer-portal/types';
import { CpWidgetProps } from '../../types/widget';
import { CpVideosRendererWidgetData } from './types';
import { CpScrollableSideMenu } from './variants/video-list-scrollable-side-menu';
import { CpSingleVideo } from './variants/video-list-single-video';
import { CpVerticalVideoStack } from './variants/video-list-vertical-video-stack';
import { CpVideoGrid } from './variants/video-list-video-grid';

export const CpVideoListWidget: React.FC<CpWidgetProps> = ({
  disabled,
  data,
  widget,
  projectId,
  onRuntimeConfigChange,
  runtimeConfig,
}) => {
  const widgetData = useMemo(
    () => data as any as CpVideosRendererWidgetData,
    [data],
  );

  switch (widget?.widgetVariantType) {
    case CpWidgetVariantType.SingleVideo:
      return (
        <CpSingleVideo
          disabled={disabled}
          data={widgetData}
          widget={widget}
          projectId={projectId}
          onRuntimeConfigChange={onRuntimeConfigChange}
          runtimeConfig={runtimeConfig}
        />
      );
    case CpWidgetVariantType.VerticalVideoStack:
      return (
        <CpVerticalVideoStack
          disabled={disabled}
          data={widgetData}
          widget={widget}
          projectId={projectId}
          onRuntimeConfigChange={onRuntimeConfigChange}
          runtimeConfig={runtimeConfig}
        />
      );
    case CpWidgetVariantType.VideoListGrid:
    case undefined:
      return (
        <CpVideoGrid
          disabled={disabled}
          data={widgetData}
          widget={widget}
          projectId={projectId}
          onRuntimeConfigChange={onRuntimeConfigChange}
          runtimeConfig={runtimeConfig}
        />
      );

    case CpWidgetVariantType.ScrollableSideMenu:
      return (
        <CpScrollableSideMenu
          disabled={disabled}
          data={widgetData}
          widget={widget}
          projectId={projectId}
          onRuntimeConfigChange={onRuntimeConfigChange}
          runtimeConfig={runtimeConfig}
        />
      );
    default:
      return <></>;
  }
};
